import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../api/Request';
import { ProgressContext } from '../../components/Context/progressContext';
import MarketingNavigation from '../../navigation/marketing';
import { showArticleBlock } from '../../utils/static-pages/function';
import { PAGES_SLUG } from '../../utils/static-pages/model';
import { ShowNotification } from '../../utils/notification/snackbarUtils';

export default function Events() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.EVENTS,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        }

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Christian financial advisors | Upcoming Events</title>
                <meta name="description" content="Discover meaningful connections and financial wisdom at Kingdom Advisors' upcoming events. Purchase Redeeming Money conference tickets today." />
            </Head>
            <MarketingNavigation>
                {articleBlocks && (
                    <div className='events'>
                        {articleBlocks.map((item, index) => (
                            showArticleBlock(item, index)
                        ))}
                    </div>
                )}
            </MarketingNavigation>
        </>
    )
}

Events.getLayout = page => <>{page}</>;
Events.isPublic = true;
